import React from "react";
import styles from "./ExpirationContent.css";
import messages from "./locales";
import { Button } from "../Button";

import TrafficCone from "./images/traffic-cone.svg";
import HeartBox from "./images/heart-box.svg";
import TimeTurner from "./images/time-turner.svg";

export const ExpirationContent = () => (
  <div className={styles.background}>
    <TrafficCone className={styles.trafficCone} />
    <span className={styles.header}>{messages.header}</span>
    <p className={styles.subheader}>
      <span> {messages.subheader_firstLine} </span>
      <span> {messages.subheader_secondLine} </span>
    </p>
    <div className={styles.reasons}>
      <HeartBox className={styles.reasons_heartBox} />
      <div className={styles.reasons_item}>
        <span className={styles.reasons_item_header}>
          {messages.reason_1_header}
        </span>
        <span className={styles.reasons_item_text}>
          {messages.reason_1_text}
        </span>
      </div>
    </div>
    <div className={styles.reasons}>
      <TimeTurner className={styles.reasons_timeTurner} />
      <div className={styles.reasons_item}>
        <span className={styles.reasons_item_header}>
          {messages.reason_2_header}
        </span>
        <span className={styles.reasons_item_text}>
          {messages.reason_2_text}
        </span>
      </div>
    </div>
    <Button
      href="https://cobli.co/conheca-cobli"
      text={messages.cta_cobli_website}
      visualWeight="primary"
      shape="square"
      extraClassName={styles.websiteButton}
    />
  </div>
);
